import { Link } from "react-router-dom";
import { Button, type ButtonProps } from "@/shared/components/shadcn/Button";

export interface EmptyStateProps {
  message: string;
  title?: string;
  action?: {
    label: string;
    ariaLabel?: string;
    variant?: ButtonProps["variant"];
  } & (
    | { onClick: () => void; to?: never }
    | { to: string; onClick?: never }
  );
}

export function EmptyState({
  message,
  title,
  action,
}: EmptyStateProps) {
  return (
    <div role="status" className="space-y-3 rounded-[20px] border border-dashed border-border bg-card px-5 py-7 text-center text-muted-foreground">
      {title && <h2 className="text-[21px] font-bold text-foreground">{title}</h2>}
      <p className="text-sm leading-relaxed">{message}</p>
      {action && (
        <div className="flex justify-center">
          {action.to !== undefined ? (
            <Button asChild variant={action.variant}>
              <Link to={action.to} aria-label={action.ariaLabel}>{action.label}</Link>
            </Button>
          ) : (
            <Button onClick={action.onClick} variant={action.variant} aria-label={action.ariaLabel}>{action.label}</Button>
          )}
        </div>
      )}
    </div>
  );
}
